function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
import { cloneDeep as c } from "./cloneDeep.js";
import { clone as A } from "../../object/clone.js";
import { isPrimitive as K } from "../../predicate/isPrimitive.js";
import { getSymbols as O } from "../_internal/getSymbols.js";
import { isArguments as h } from "../predicate/isArguments.js";
import { isObjectLike as j } from "../predicate/isObjectLike.js";
import { isPlainObject as B } from "../predicate/isPlainObject.js";
import { isTypedArray as w } from "../predicate/isTypedArray.js";
function R(f) {
  for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    e[_key - 1] = arguments[_key];
  }
  var t = e.slice(0, -1),
    r = e[e.length - 1];
  var m = f;
  for (var l = 0; l < t.length; l++) {
    var o = t[l];
    m = s(m, o, r, new Map());
  }
  return m;
}
function s(f, e, t, r) {
  if (K(f) && (f = Object(f)), e == null || _typeof(e) != "object") return f;
  if (r.has(e)) return A(r.get(e));
  if (r.set(e, f), Array.isArray(e)) {
    e = e.slice();
    for (var l = 0; l < e.length; l++) {
      var _e$l;
      e[l] = (_e$l = e[l]) !== null && _e$l !== void 0 ? _e$l : void 0;
    }
  }
  var m = [].concat(_toConsumableArray(Object.keys(e)), _toConsumableArray(O(e)));
  for (var _l = 0; _l < m.length; _l++) {
    var o = m[_l];
    var i = e[o],
      n = f[o];
    if (h(i) && (i = _objectSpread({}, i)), h(n) && (n = _objectSpread({}, n)), (typeof Buffer === "undefined" ? "undefined" : _typeof(Buffer)) < "u" && Buffer.isBuffer(i) && (i = c(i)), Array.isArray(i)) if (_typeof(n) == "object" && n != null) {
      var u = [],
        d = Reflect.ownKeys(n);
      for (var y = 0; y < d.length; y++) {
        var b = d[y];
        u[b] = n[b];
      }
      n = u;
    } else n = [];
    var p = t(n, i, o, f, e, r);
    p != null ? f[o] = p : Array.isArray(i) || j(n) && j(i) ? f[o] = s(n, i, t, r) : n == null && B(i) ? f[o] = s({}, i, t, r) : n == null && w(i) ? f[o] = c(i) : (n === void 0 || i !== void 0) && (f[o] = i);
  }
  return f;
}
export { R as mergeWith };